// src/main.jsx
// React import is still needed for JSX even if not directly referenced
import React from 'react'; // eslint-disable-line no-unused-vars
import ReactDOM from 'react-dom/client';
import { ChakraProvider, ColorModeScript } from '@chakra-ui/react';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';
import theme from './theme';
import * as Sentry from '@sentry/react';

Sentry.init({
  environment:
    import.meta.env.MODE === 'development' ? 'development' : 'production',

  dsn: 'https://a43be74f50056ac68c815d82055fed72@o4508677853216768.ingest.us.sentry.io/4509435779350528',
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
});

// Add a comment explaining the StrictMode behavior
// StrictMode intentionally double-invokes certain functions in development mode
// to help detect side effects. This can cause API calls to be made twice.
// For production, this doesn't happen, but during development it can cause issues.
// If you're experiencing double API calls during development, you can temporarily
// remove StrictMode for testing.

ReactDOM.createRoot(document.getElementById('root')).render(
  // <React.StrictMode>
  <HelmetProvider>
    <ChakraProvider theme={theme}>
      <ColorModeScript initialColorMode={theme.config.initialColorMode} />
      <App />
    </ChakraProvider>
  </HelmetProvider>
  // </React.StrictMode>
);
